import {baseUrl} from'../config';

export const commentController ={
    Url:baseUrl+'/api/comment',
} 